<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" >
                <!-- <el-form-item label="类型">
                    <el-select v-model="form.typeId" clearable  placeholder="全部">
                        <el-option
                            v-for="item in typeOption"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> -->
            </el-form>
            <el-button type="primary" @click="edit({})">新增</el-button>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="title"
                    label="标题" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="typeName"
                    label="分类" >
                </el-table-column>
                <el-table-column
                    min-width="200"
                    label="标签">
                    <template slot-scope="scope">
                        <tag-group :tags="scope.row.tagArray" size="mini" ></tag-group>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="contentFormHtml"
                    label="内容" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    label="优先显示" >
                    <template slot-scope="scope">
                        <div class="fx-col fx-center" style="color:#69e93f" v-if="scope.row.enable"> 
                              优先显示
                        </div>
                        <!-- <div class="fx-col fx-center" style="color:#F56C6C" v-if="scope.row.enable == false"> 
                              {{scope.row.typeName}}
                        </div> -->
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="createTime"
                    label="时间" >
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="180"
                >
                    <template slot-scope="scope">
                        <el-link type="primary" @click="edit(scope.row)"
                                 :underline="false" ><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                        <el-popconfirm @onConfirm="del(scope.row)"
                                       title="确认删除该内容吗？" >
                            <el-link type="danger" slot="reference"
                                     :underline="false" ><i class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                        </el-popconfirm>

                    </template>
                </el-table-column>
            </el-table>
        </div>
        <ArticleEditDrawer v-if="showEdit" :item="currentArticle"
                            @close="showEdit = false" @submit="loadData"></ArticleEditDrawer>
    </div>
</template>

<style scoped>
    .order_btn {
        display: inline-block;
        background: var(--primary);
        color: white;
        margin: 0 5px;
        cursor: pointer;
        padding: 2px;
    }
</style>
<style>

</style>

<script>

    import {mapMutations} from 'vuex';
    import ArticleEditDrawer from "./ArticleEditDrawer";
    export default {
        components: {
            ArticleEditDrawer,
        },
        props: [
            "attr"
        ],
        data() {
            return {
                form:{
                    keywords: "",
                },
                typeOption: {},
                currentArticle: {},
                tableData: [ ],
                showEdit: false,
                editItem: {},
            }

        },

        watch: {
           "form": {
                handler: function (newValue) {
                    //this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true
            }
        },

        methods: {
            ...mapMutations(["openTab"]),
            edit(item) {
                this.currentArticle = {...item};
                this.showEdit = true;
            },
           
            del(item) {
                this.$ajaxGet("/article/delArticleById/" + item.id, (data) => {
                    this.loadData();
                })
            },
            loadData() {
                this.$ajaxPost("/article/listArticle",
                {form: this.form,}, (data) => {
                    this.tableData = data.result;
                    this.showEdit = false;
                })
            },
            loadType() {
                this.$ajaxGet("/articleType/listArticleType", (data) => {
                    this.typeOption = data.result;
                })
            },
        },

        created() {
            this.loadData();
            this.loadType();
        }

    }
</script>
